import { render, staticRenderFns } from "./pointRoute.vue?vue&type=template&id=4db1505a&scoped=true"
import script from "./pointRoute.vue?vue&type=script&lang=js"
export * from "./pointRoute.vue?vue&type=script&lang=js"
import style0 from "./pointRoute.vue?vue&type=style&index=0&id=4db1505a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db1505a",
  null
  
)

export default component.exports